import * as types from './types';

export default ({
    // RESET STATE
    [types.RESET_STATE] (state) {
        state.steps.current = 0;
        state.orderCreated = false;
        state.selection = {
            activeBuilding: 0,
            activeField: 0,
            activePanels: [],
            fieldName: '',
        };
        state.panels = [];
        state.customer = {
            salutation: '',
            company: '',
            firstname: '',
            lastname: '',
            address: '',
            zip: '',
            city: '',
            phone: '',
            email: '',
            confirmEmail: '',
        };
    },
    // STORAGE
    [types.UPDATE_STORE] (state) {
        if (sessionStorage.getItem('store')) {
            this.replaceState(
                Object.assign(state, JSON.parse(sessionStorage.getItem('store')))
            );
        }
    },
    // APPLICATION OPTIONS
    [types.UPDATE_STEPS] (state, payload) {
        state.steps.current = payload;
    },
    [types.SET_WORDING] (state, payload) {
        state.wording = payload;
    },
    [types.SET_SUPPLIER] (state, payload) {
        state.supplier = payload;
    },
    [types.SET_MAX_PANELS] (state, payload) {
        state.maxPanels = payload.max_panels_per_customer;
    },
    // SET NOTIFICATION
    [types.SET_NOTIFICATION] (state, payload) {
        state.notification = payload;
    },
    // SET LOADER
    [types.SET_LOADER] (state, payload) {
        state.loader = payload;
    },
    // SELECTION OPTIONS
    [types.SET_BUILDINGS] (state, payload) {
        state.buildings = payload;
    },
    [types.SET_BUILDING] (state, payload) {
        let building = state.buildings.filter(building => building.id === payload.id);

        if (building.length > 0) {
            state.buildings[state.buildings.indexOf(building)] = building;
        } else {
            state.buildings.push(payload);
        }
    },
    [types.SET_ACTIVE_BUILDING] (state, payload) {
        if (state.selection.activeBuilding !== payload) {
            // Important to reset field  and panel selection when changing building
            state.selection.activeField = 0;
            state.panels = [];
        }
        state.selection.activeBuilding = payload;
    },
    [types.SET_ACTIVE_FIELD] (state, payload) {
        if (state.selection.activeField !== payload.id) {
            // Important to reset panel selection when changing fields
            state.panels = [];
        }
        state.selection.activeField = payload.id;
        state.selection.fieldName = 'Sektor ' + (parseInt(payload.index) + 1);
    },
    [types.SET_PANELS] (state, payload) {
        state.panels = [];

        const field = this.getters.get_field_by_id(state.selection.activeField);
        field.panels = payload;

        const panelsArray = field.panels;

        let salutationParse = function (salutation) {
            let name;
            if (salutation === 'Mr') {
                name = 'Herr';
            } else if (salutation === 'Mrs') {
                name = 'Frau';
            } else if (salutation === 'Firma') {
                name = 'Firma';
            } else {
                name = '';
            }
            return {
                value: salutation,
                name: name,
            };
        };
        for (let ii = 0; ii < panelsArray.length; ii++) {
            if (panelsArray[ii].owner !== undefined && panelsArray[ii].owner !== null) {
                let salutation = salutationParse(panelsArray[ii].owner.salutation);
                state.panels.push({
                    ...panelsArray[ii],
                    selected: false,
                    owner: {
                        ...panelsArray[ii].owner,
                        has: false,
                        salutation: salutation,
                    }
                });
            } else {
                state.panels.push({
                    ...panelsArray[ii],
                    selected: false,
                    owner: {
                        company: '',
                        firstname: '',
                        lastname: '',
                        email: '',
                        phone: '',
                        city: 'St.Gallen',
                        street: '',
                        zip: '',
                        house_nr: '',
                        has: false,
                        salutation: {
                            name: '',
                            value: '',
                        },
                    }
                });
            }

        }
    },
    // PANEL OPTIONS
    [types.UPDATE_PANEL_PRICE] (state, payload) {
        var panelsArr = state.panels;
        for (var ii = 0; ii < panelsArr.length; ii++) {
            if (panelsArr[ii].id === payload.id) {
                panelsArr[ii].panel_cost = payload.panel_cost;
            }
        }
    },
    [types.UPDATE_PANEL_STATUS] (state, payload) {
        var panelsArr = state.panels;
        for (var ii = 0; ii < panelsArr.length; ii++) {
            if (panelsArr[ii].id === payload.id) {
                panelsArr[ii].status = payload.status;
                panelsArr[ii].status_name = payload.status_name;
            }
        }
    },
    [types.SET_SELECTED_PANEL] (state, payload) {
        state.selection.activePanels.push(payload.id);
        var panelsArr = state.panels;
        for (var ii = 0; ii < panelsArr.length; ii++) {
            if (panelsArr[ii].id === payload.id) {
                panelsArr[ii].selected = true;
                panelsArr[ii].panel_name = payload.name;
            }
        }
    },
    [types.REMOVE_SELECTED_PANEL] (state, payload) {
        state.selection.activePanels.splice(state.selection.activePanels.indexOf(payload), 1);
        var panelsArr = state.panels;
        for (var ii = 0; ii < panelsArr.length; ii++) {
            if (panelsArr[ii].id === payload) {
                panelsArr[ii].selected = false;
            }
        }
    },
    [types.ERASE_SELECTED_PANEL] (state) {
        state.selection.activePanels = [];
    },
    [types.UPDATE_PANEL_NAME] (state, payload) {
        var panelsArr = state.panels;
        for (var ii = 0; ii < panelsArr.length; ii++) {
            if (panelsArr[ii].id === payload.id) {
                panelsArr[ii].panel_name = payload.name;
                panelsArr[ii].panel_name_changed = !payload.resetName;
            }
        }
    },
    [types.TOGGLE_OWNER_PANEL] (state, payload) {
        var panelsArr = state.panels;
        for (var ii = 0; ii < panelsArr.length; ii++) {
            if (panelsArr[ii].id === payload) {
                panelsArr[ii].owner.has = !panelsArr[ii].owner.has;
                panelsArr[ii].owner.city = 'St.Gallen';
            }
        }
    },
    [types.SET_OWNER] (state, payload) {
        var panelsArr = state.panels;
        for (var ii = 0; ii < panelsArr.length; ii++) {

            if (panelsArr[ii].id === payload.id) {

                panelsArr[ii].owner[payload.key] = payload.value;
            }
        }
    },
    // PANEL OPTIONS
    [types.SET_CUSTOMER] (state, payload) {
        state.customer[payload.key] = payload.value;
    },
    // PANEL OPTIONS
    [types.ORDER_CREATED] (state) {
        state.orderCreated = true;
    },
    // RESOURCES
    [types.UPDATE_PDF] (state, payload) {
        state.pdf = payload;
    },
});



// WEBPACK FOOTER //
// ./src/store/mutations.js